export default __webpack_public_path__ + "2bc972441bdd3bfff5aa6c397d9d31d4.svg";